import { render, staticRenderFns } from "./DemoVerificador.vue?vue&type=template&id=52411eff&"
import script from "./DemoVerificador.vue?vue&type=script&lang=js&"
export * from "./DemoVerificador.vue?vue&type=script&lang=js&"
import style0 from "./DemoVerificador.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports